import { WorldpayCustomisationButtons } from '../../models/worldpay/worldpay-customisation-buttons.interface';
import { mockWorldpayCustomisationBorder } from './worldpay-customisation-border.mock';
import { mockWorldpayCustomisationInteraction } from './worldpay-customisation-interaction.mock';

export const mockWorldpayCustomisationButtons: WorldpayCustomisationButtons = {
  backgroundColor: '#000000',
  border: mockWorldpayCustomisationBorder,
  color: '#00000',
  focus: mockWorldpayCustomisationInteraction,
  fonts: [],
  hover: mockWorldpayCustomisationInteraction,
};
